export const LANDING_PAGE = '/';
export const DASHBOARD_PAGE = '/dashboard';
export const BOOKMARK_PAGE = '/bookmark';
export const FAVORITE_PAGE = '/favorite';
export const QA_QUESTION_LIST_PAGE = '/qa';
export const QA_QUESTION_PAGE = '/qa';
export const QA_QUESTION_ASK_PAGE = '/qa/ask';
export const QA_QUESTION_ASKED_PAGE = '/qa/asked';
export const NOTES_PAGE = '/notes';
export const NOTES_DETAILS_PAGE = '/notes/:courseId/book/:bookId';
export const NOTES_PRINT_PAGE = '/noteprint';
export const MAIN_MODE_COURSE_PAGE = '/course';
export const MAIN_MODE_COURSE_CHALLENGE_MODE_PAGE = 'challenge-mode';
export const MAIN_MODE_COURSE_VIDEO_MODE_PAGE = 'video-mode';
export const MAIN_MODE_COURSE_LIVE_MODE_PAGE = 'live-mode';
export const MAIN_MODE_COURSE_FLASHCARD_LANDING_PAGE = 'flash-card-landing';
export const MAIN_MODE_COURSE_EXERCISE_PAGE = 'exercise';
export const MAIN_MODE_COURSE_EVENTS_PAGE = 'events';
export const MAIN_MODE_COURSE_FAVORITE_PAGE = 'favorite';
export const MAIN_MODE_COURSE_RANKING_PAGE = 'ranking';
export const MAIN_MODE_COURSE_MATERIAL_PAGE = 'material';
export const MAIN_MODE_COURSE_CLASSROOM_PAGE = 'classroom';
export const MINI_MODE_COURSE_PAGE = '/mini-course';
export const FREE_MODE_COURSE_PAGE = '/free-course';
export const TRAIL_MODE_COURSE_PAGE = '/trail-course';
export const MAIN_MODE_BOOK_PAGE = '/course/:courseId/book/:bookId';
export const MINI_MODE_BOOK_PAGE = '/mini-course/:courseId/book/:bookId';
export const FREE_MODE_BOOK_PAGE = '/free-course/:courseId/book/:bookId';
export const READER_MODE_BOOK_PAGE = '/reader-course/:courseId/book/:bookId';
export const TRAIL_MODE_BOOK_PAGE = '/trail-course/:courseId/book/:bookId';
export const EXERCISE_PAGE = '/exercise';
export const EVENTS_PAGE = '/events';
export const IDENTITY_PAGE = '/identity';
export const REFERRAL_PAGE = '/referral';
export const MESSAGE_PAGE = '/message';
export const SETTING_PAGE = '/setting';
export const LOGIN_PAGE = '/login';
export const LOGIN_KECUHUI_PAGE = '/login-kecuhui';
export const LOGIN_PHONE_PAGE = '/login-phone';
export const LOGOUT_PAGE = '/logout';
export const PASSWORD_FORGET_PAGE = '/password/forget';
export const PASSWORD_CONFIRM_PAGE = '/password/confirm';
export const PASSWORD_RESET_PAGE = '/password/reset';
export const PASSWORD_SUCCESS_PAGE = '/password/success';
export const MUST_READ_PAGE = '/must-read';
export const MUST_READ_API_PAGE = '/api/nuxt/students/mustread.html';
export const LAYOUT_TEMPLATE_PAGE = '/layout-template';
export const LAYOUT_TEMPLATE1_PAGE = '/layout-template1';
export const LAYOUT_TEMPLATE2_PAGE = '/layout-template2';
export const PURE_MODE_COURSE_PAGE = '/video-mode-course/:courseId';
export const PURE_MODE_BOOK_PAGE = '/video-mode-course/:courseId/book/:bookId';
export const MALL_PAGE = '/mall';
export const MALL_ITEM_PAGE = '/mall/cpa';
export const MALL_CATEGORY_PAGE = '/mall/:category';
export const MALL_GOOD_PAGE = '/mall/:category/';
export const MALL_CATEGORY_COUPON_PAGE = '/mall/coupon';
export const MALL_GOOD_COUPON_PAGE = '/mall/coupon/';
//export const MALL_ORDER_PAGE = '/mall/order/';
export const MALL_ORDER_PAGE = '/order';
export const MALL_TRADE_PAGE = '/trade/:tradeType/:tradeId';
export const MALL_WRITE_OFF_PAGE = '/write-off/:goodId';
//export const MALL_PAYPAL_PAGE = '/mall/order/paypal';
export const MALL_PAYPAL_PAGE = '/order/paypal';
export const ACHIEVEMENTS_PAGE = '/achievements';
export const READER_PAGE = '/reader';
export const POINTS_PAGE = '/points';
export const PRIVACY_PAGE = '/privacy';
export const ACCOUNT_CANCELLATION_PAGE = '/account-cancellation';
export const RANKING_PAGE = '/ranking/:courseId';
export const ACTIVITY_TRANSCRIPT_PAGE = '/activity/transcript/:paperId';
export const EVENT_REDIRECT_PAGE = '/event-redirect';
export const ALL_COURSES_PAGE = '/all-courses';
export const COUPON_PAGE = '/coupon';
export const FLASH_CARD_DETAIL_PAGE = '/flash-card-detail';
export const FLASH_CARD_FAVORITE_PAGE = '/flash-card-favorite';
export const FLASH_CARD_LANDING_PAGE = '/flash-card-landing';
export const TEACHERS_PAGE = '/teachers';
export const APP_PAGE = '/app';
export const ABOUT_PAGE = '/about';
export const LEGAL_PAGE = '/legal';
export const TRAIL_LESSON_20426_PAGE = '/all-courses';

export const TRAINING_CAMP_PAGE = '/training-camp/:courseId';
export const TRAINING_CAMP_PERSONAL_PAGE = '/training-camp-personal/:courseId';

export const TRAINING_CAMPS_PAGE = '/training-camps/:courseId';

export const ORDER_DETAIL_PAGE = '/order-detail';
export const MY_ORDER_PAGE = '/my-order';
export const MY_ORDER_LIST_PAGE = '/my-order-list';
export const IM_TEAM_ANNOUNCEMENT_PAGE = '/im-team-announcement';

export const MESSAGE_BK_PAGE = '/message-bk';
export const MALL_ESG_REGISTRATION_PAGE = '/esg-registration';
export const ESG_ORDER_COMPLETED_PAGE = '/esg-order-completed';

export const ALUMNI_PAGE = '/alumni';
export const AI_PAGE = '/ai';

// export const INVOICE_PAGE = '/invoice';
export const CAREER_PAGE = '/career';

//export const AGREEMENT_PAGE = '/agreement';

export const PLV_LIVE_REDIRECT_PAGE = '/plv-live-redirect';
